module.exports = __webpack_public_path__ + "static/media/4.fa06c47b.png";